
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/historical/cc-jl",
      function () {
        return require("private-next-pages/en/docs/historical/cc-jl/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/historical/cc-jl"])
      });
    }
  